module.exports = __webpack_public_path__ + "./Marco_95311472dc96f4a29fb2b2e634e4bb19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Marco.jpg
// module id = 536
// module chunks = 0